module.exports = __webpack_public_path__ + "img/12.6c973c9a.jpg";